import { h, render, Component } from 'preact';
import RangeValue from '../libs/RangeValue';
import getSharedValue from '../libs/getSharedValue';
import { observer } from 'mobx-react';
import SharedFiltersStore from "./store/SharedFiltersStore";

export default observer(
    class FilterItemRange extends Component {
        constructor(props) {
            super(props);

            this.minInputValue = getSharedValue(props.sharedState, 'min');
            this.maxInputValue = getSharedValue(props.sharedState, 'max');
        }

        handleKeypress(e) {
            if(!(e.charCode >= 48 && e.charCode <= 57)) {
                e.preventDefault();
            }
        }

        handleBlur = e => {
            const { target } = e;

            if(typeof(this.props.onChange) === 'function') {

                let value = parseInt(target.value);
                const rangeType = target.getAttribute('data-range-type');

                if(!isNaN(value)) {
                    if (rangeType === 'min') {
                        value = Math.max(value, this.props.minValue);
                        this.minInputValue = value;
                    } else {
                        value = Math.min(value, this.props.maxValue);
                        this.maxInputValue = value;
                    }
                } else {
                    value = '';
                }

                if (rangeType === 'min') {
                    this.minInputValue = value;
                } else {
                    this.maxInputValue = value;
                }

                target.value = value;
                SharedFiltersStore.saveFilterMinMaxStatus(this.props.id, this.minInputValue, this.maxInputValue);
                this.props.onChange(
                    this.props.id,
                    new RangeValue(
                        this.minInputValue ? this.minInputValue : this.props.minValue,
                        this.maxInputValue ? this.maxInputValue : this.props.maxValue,
                        !!(this.minInputValue||this.maxInputValue)
                    )
                );
            }
        }

        render() {
            const props = this.props;

            const minValue = getSharedValue(props.sharedState, 'min');
            const maxValue = getSharedValue(props.sharedState, 'max');

            return (
                <fieldset class="catalogue__filter__group">
                    <legend
                        class="catalogue__filter__group__title">
                        { props.title }
                    </legend>

                    <div class="catalogue__filter__range">
                        <div class="catalogue__filter__range__item">
                            <input
                                class="catalogue__filter__range__field"
                                type="text"
                                placeholder={props.minTitle}
                                data-range-type="min"
                                onKeyPress={this.handleKeypress}
                                maxLength={4}
                                onBlur={this.handleBlur}
                                value={minValue}
                            />

                            <span class="catalogue__filter__range__label">От</span>
                        </div>
                        <div class="catalogue__filter__range__item">
                            <input
                                class="catalogue__filter__range__field"
                                type="text"
                                placeholder={props.maxTitle}
                                data-range-type="max"
                                onKeyPress={this.handleKeypress}
                                maxLength={4}
                                onBlur={this.handleBlur}
                                value={maxValue}
                            />
                            <span class="catalogue__filter__range__label">До</span>
                        </div>
                    </div>
                </fieldset>
            )
        }
    }
);